import { all } from 'redux-saga/effects';

import {
  authWatcher,
  checkAuthenticationWatcher,
  checkSsoAzureConfigWatcher,
  checkSsoJwtConfigWatcher,
  checkSsoSamlConfigWatcher,
  checkPasswordResetTokenWatcher,
  createNewPasswordWatcher,
  forgotPasswordWatcher,
  resetPasswordWatcher,
  signUpSagaWatcher,
} from 'watchers/auth.watcher.saga';
import {
  getAppConfigSagaWatcher,
  getProductCurrencySagaWatcher,
  getAppOptionsSagaWatcher,
  getCustomMenuItemsSagaWatcher,
  getUserPointsSagaWatcher,
  patchUserCGUSagaWatcher,
  getFeatureByNameSagaWatcher,
} from 'watchers/app.watcher.saga';
import {
  getUserChallengesSagaWatcher,
  getUserChallengeSagaWatcher,
  getUserChallengeDeclarationsSagaWatcher,
  getUserChallengeDeclarationSagaWatcher,
  getTotalUsersParticipationSagaWatcher,
  postUserParticipationSagaWatcher,
  getChallengeResultsSagaWatcher,
  getChallengeRanksSagaWatcher,
  getChallengeResultVoteSagaWatcher,
  getChallengeResultUnvoteSagaWatcher,
  postUserChallengePhotoSagaWatcher,
  setSelectedChallengeDataSagaWatcher,
} from 'watchers/challenge.watcher.saga';
import {
  getContentSagaWatcher,
  getCategoryContentsSagaWatcher,
} from 'watchers/content.watcher.saga';
import { getBadgeUserDetailsSagaWatcher } from 'watchers/badge.watcher.saga';
import {
  getWidgetPointsDetailsSagaWatcher,
  getWidgetGlobalViewChallengesSagaWatcher,
} from 'watchers/widget.watcher.saga';
import {
  getProductBrandsSagaWatcher,
  getProductRangesSagaWatcher,
  getProductSagaWatcher,
} from 'watchers/product.watcher.saga';

export default function* rootSaga() {
  yield all([
    authWatcher(),
    checkAuthenticationWatcher(),
    checkSsoAzureConfigWatcher(),
    checkSsoJwtConfigWatcher(),
    checkSsoSamlConfigWatcher(),
    checkPasswordResetTokenWatcher(),
    createNewPasswordWatcher(),
    getAppConfigSagaWatcher(),
    getProductCurrencySagaWatcher(),
    getAppOptionsSagaWatcher(),
    getBadgeUserDetailsSagaWatcher(),
    getContentSagaWatcher(),
    getCategoryContentsSagaWatcher(),
    getCustomMenuItemsSagaWatcher(),
    getTotalUsersParticipationSagaWatcher(),
    getUserChallengesSagaWatcher(),
    getUserChallengeSagaWatcher(),
    getUserChallengeDeclarationsSagaWatcher(),
    getUserChallengeDeclarationSagaWatcher(),
    getUserPointsSagaWatcher(),
    getWidgetPointsDetailsSagaWatcher(),
    getWidgetGlobalViewChallengesSagaWatcher(),
    postUserParticipationSagaWatcher(),
    getChallengeResultsSagaWatcher(),
    getChallengeRanksSagaWatcher(),
    getChallengeResultVoteSagaWatcher(),
    getChallengeResultUnvoteSagaWatcher(),
    forgotPasswordWatcher(),
    postUserChallengePhotoSagaWatcher(),
    resetPasswordWatcher(),
    signUpSagaWatcher(),
    patchUserCGUSagaWatcher(),
    getFeatureByNameSagaWatcher(),
    getProductBrandsSagaWatcher(),
    getProductRangesSagaWatcher(),
    getProductSagaWatcher(),
    setSelectedChallengeDataSagaWatcher(),
  ]);
}
